<template>
  <div class="columns is-multiline">
    <div class="column is-4" v-for="(resource, index) in resources" :key="index" v-if="resources">
      <ResourceThumbnail :resource="resource"></ResourceThumbnail>
    </div>
  </div>
</template>

<script>
import ResourceThumbnail from '@/components/ResourceThumbnail'

export default {
  components: {
    ResourceThumbnail
  },

  props: {
    resources: {
      type: Array,
      required: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ResourceThumbnailList.vue